module.exports = function () {
    const players = document.querySelectorAll(".lazy-lottie-player");
    if ( !players.length ) return;
    
    const cacheAnimation = {};
    let fistLoad = false;
    
    async function loadAnimation(url) {
        if (cacheAnimation[url]) return cacheAnimation[url];
        const response = await fetch(url);
        const json = await response.json();
        cacheAnimation[url] = json;
        return json;
    }
    
    const observer = new IntersectionObserver(async (entries) => {
        for (const entry of entries) {
            if ( entry.isIntersecting ) {
                if ( !fistLoad ) {
                    await import("@lottiefiles/lottie-player");
                }
                
                const player = entry.target;
                observer.unobserve(entry.target)
                const animation = await loadAnimation(player.dataset.src);
                player.load(animation);
                player.play();
            }
        }
    })

    for (const player of players) {
        observer.observe(player)
    }
}